import { render } from "./TeamMembers.vue?vue&type=template&id=5ed2ee14&ts=true"
import script from "./TeamMembers.vue?vue&type=script&lang=ts"
export * from "./TeamMembers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__